import { LogicNodeDefinition } from '../LogicNodeDefinition';

export const WireNode: LogicNodeDefinition = {
  type: 'WIRE',
  createDefaultState: () => null,
  process: (input) => input,
};
